import React, { useEffect, useState } from "react";
import Accordion from "react-bootstrap/Accordion";
import T from "./Translate/T";
import { useTranslate } from "../context/TranslateContext";

const FAQs = () => {
  const { currentLang, translateBatch, isEnglish } = useTranslate();
  const [translatedFaqs, setTranslatedFaqs] = useState([]);

  const faqsData = [
    {
      question: "What services do you offer?",
      answer:
        "I offer full stack web development services including PHP/Laravel API architecture, React and Next.js front-end development, database design, AWS cloud infrastructure, and legacy system migration. I also provide technology consultancy and business analysis support.",
    },
    {
      question: "What is your development process?",
      answer:
        "I follow an agile methodology with clear communication at every stage. This includes initial requirements gathering, wireframe creation, iterative development sprints, code reviews, testing, and deployment. You'll have visibility into progress throughout the project.",
    },
    {
      question: "What technologies do you specialize in?",
      answer:
        "My core stack includes PHP, Laravel, React, Next.js, Vue.js, TypeScript, MySQL, PostgreSQL, and AWS services. I also have extensive experience with RESTful APIs, microservices architecture, Docker, and CI/CD pipelines.",
    },
    {
      question: "Do you work with international clients?",
      answer:
        "Yes! I'm bilingual (English/Spanish) and have worked with clients across North America, Latin America, and internationally. I'm experienced in remote collaboration and can adapt to different time zones and communication preferences.",
    },
    {
      question: "What is your experience with enterprise projects?",
      answer:
        "I have 13+ years of experience delivering enterprise-grade platforms for clients including Scotiabank, TELUS, Aviva, and Air Miles. I specialize in building scalable, secure solutions that meet enterprise requirements and compliance standards.",
    },
  ];

  // Translate FAQs when language changes
  useEffect(() => {
    const translateFaqs = async () => {
      if (isEnglish) {
        setTranslatedFaqs(faqsData);
        return;
      }

      try {
        // Collect all texts to translate (questions and answers)
        const textsToTranslate = faqsData.flatMap(faq => [faq.question, faq.answer]);
        
        const results = await translateBatch(textsToTranslate, currentLang);
        
        // Map results back to FAQ structure
        const translated = faqsData.map((faq, index) => ({
          ...faq,
          question: results[index * 2] || faq.question,
          answer: results[index * 2 + 1] || faq.answer,
        }));
        
        setTranslatedFaqs(translated);
      } catch (error) {
        console.error("Translation error:", error);
        setTranslatedFaqs(faqsData);
      }
    };

    translateFaqs();
  }, [currentLang, isEnglish]);

  const displayFaqs = translatedFaqs.length > 0 ? translatedFaqs : faqsData;

  return (
    <section id="faq" className="section bg-light">
      <div className="container">
        <div className="row gy-5">
          <div className="col-lg-6 order-1 order-lg-0 wow fadeInUp">
            {/* Heading */}
            <p className="text-center text-lg-start mb-2">
              <span className="bg-primary text-dark px-2">FAQ</span>
            </p>
            <h2 className="text-10 fw-600 text-center text-lg-start mb-5">
              <T>Have any questions?</T>
            </h2>
            {/* Heading end*/}
            <Accordion flush defaultActiveKey="0">
              {displayFaqs.length > 0 &&
                displayFaqs.map((faq, index) => (
                  <Accordion.Item eventKey={index} key={index}>
                    <Accordion.Header>{faq.question}</Accordion.Header>
                    <Accordion.Body
                      dangerouslySetInnerHTML={{ __html: faq.answer }}
                    ></Accordion.Body>
                  </Accordion.Item>
                ))}
            </Accordion>
          </div>
          <div
            className="col-lg-6 d-flex align-items-center justify-content-center order-0 order-lg-1 wow fadeIn"
            data-wow-delay="1s"
          >
            {" "}
            <img
              className="img-fluid"
              src="images/faq.png"
              title="FAQ"
              alt="faq"
            />{" "}
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQs;